import { Button } from 'common/components';
import { Phone, Mic, MicOff, MonitorPlay, MonitorPause } from 'lucide-react';
import { CallStatusType, CallStatuses } from 'contexts/LiveKitContext';

type RenderCallButtonsProps = {
    callStatus: CallStatusType;
    onAcceptCall: () => void;
    onRejectCall: () => void;
    onHangupCall: () => void;
    isMuted: boolean;
    onMuteToggle: () => void;
    isOnHold: boolean;
    onHoldToggle: () => void;
    isConnectedToLiveKit: boolean;
};

export const RenderCallButtons = ({
    callStatus,
    onAcceptCall,
    onRejectCall,
    onHangupCall,
    isMuted,
    onMuteToggle,
    isOnHold,
    onHoldToggle,
    isConnectedToLiveKit,
}: RenderCallButtonsProps) => {
    switch (callStatus) {
        case CallStatuses.INCOMING:
            return (
                <div className='icon-button-container'>
                    <button className='icon-button icon-button-green' onClick={onAcceptCall}>
                        <Phone color='white' size={18} />
                    </button>
                    <Button
                        className='rotate-135 icon-button-red'
                        onClick={onRejectCall}
                        icon={Phone}
                        isRounded
                        iconOnly
                        size='lg'
                        variant='danger'
                    />
                </div>
            );
        case CallStatuses.IN_PROGRESS:
            return (
                <div className='icon-button-container'>
                    <button type='button' className='button-clear' onClick={onMuteToggle} style={{ minWidth: '80px' }}>
                        {isMuted ? (
                            <>
                                <Mic size={18} /> Unmute
                            </>
                        ) : (
                            <>
                                <MicOff size={18} /> Mute
                            </>
                        )}
                    </button>

                    <button type='button' className='button-clear' onClick={onHoldToggle} style={{ minWidth: '80px' }}>
                        {isOnHold ? (
                            <>
                                <MonitorPause /> Unhold
                            </>
                        ) : (
                            <>
                                <MonitorPlay /> Hold
                            </>
                        )}
                    </button>
                    <Button
                        className='icon-button-red rotate-135'
                        isLoading={!isConnectedToLiveKit}
                        onClick={onHangupCall}
                        icon={Phone}
                        isRounded
                        iconOnly
                        size='lg'
                        variant='danger'
                    />
                </div>
            );
        case CallStatuses.READY:
        default:
            return null;
    }
};
